import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon/SvgIcon";

const ExclusionBrandSafety = props => (
  <SvgIcon width="23" height="25" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M-28-26h79v78h-79z" />
      <path
        fill="#C56E5A"
        d="M11.77 0L6.12 2.19.36 4.34a.6.6 0 0 0-.36.6A33.53 33.53 0 0 0 11.08 24.8a.56.56 0 0 0 .86 0A31.28 31.28 0 0 0 22.99 4.93a.5.5 0 0 0-.36-.6l-5-1.68"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M11.5 6a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11zm-4.39 5.5a4.39 4.39 0 0 1 7.1-3.6l-5.98 6.15a4.42 4.42 0 0 1-1.02-2.68l-.1.13zm4.39 4.32c-.98 0-1.92-.34-2.68-.95l6.15-6.15c.61.76.95 1.7.95 2.68a4.42 4.42 0 0 1-4.42 4.42z"
      />
    </g>
  </SvgIcon>
);

export default ExclusionBrandSafety;
